export function removeTags(input: string): string {
  return input ? input.replace(/(<([^>]+)>)/ig, '') : '';
}
